export const selectDeselectAllOptionValue = 'selectDeselectAll';
